import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  return <section className="py-16 sm:py-24 px-4 bg-pump-dark" data-id="element-273">
      <div className="max-w-4xl mx-auto" data-id="element-274">
        <FadeIn data-id="element-275">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-12" data-id="element-276">
            ¿Cuánto vale todo esto realmente?
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-277">
          <FadeIn delay={0.1} data-id="element-278">
            <div className="flex items-center gap-4 bg-pump-surface p-4 sm:p-6 rounded-xl border border-pump-muted/50 opacity-70" data-id="element-279">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-280">
                <XIcon className="w-5 h-5 text-red-500" data-id="element-281" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-282">
                Podés contratar a un coach de oratoria y presencia escénica para
                clases privadas. Son 3 a 5 sesiones a precio de mercado. Solo
                para trabajar tu presencia en el podio.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-283">
            <div className="flex items-center gap-4 bg-pump-surface p-4 sm:p-6 rounded-xl border border-pump-muted/50 opacity-70" data-id="element-284">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-285">
                <XIcon className="w-5 h-5 text-red-500" data-id="element-286" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-287">
                Podés tomar cursos separados de storytelling, marketing personal
                y nutrición deportiva. Cada uno a precio de mercado. Sin
                integración. Sin aplicación directa al escenario de BodyPump.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-288">
            <div className="flex items-center gap-4 bg-pump-surface p-4 sm:p-6 rounded-xl border border-pump-muted/50 opacity-70" data-id="element-289">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-290">
                <XIcon className="w-5 h-5 text-red-500" data-id="element-291" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-292">
                Podés invertir meses probando estrategias de fidelización,
                armando scripts de cueing, diseñando tus propias checklists y
                desarrollando una marca personal desde cero. Sin garantías. Sin
                sistema probado.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-293">
            <div className="flex items-center gap-4 bg-pump-gold/10 p-5 sm:p-8 rounded-xl border border-pump-gold shadow-[0_0_20px_rgba(245,200,66,0.1)]" data-id="element-294">
              <div className="bg-pump-gold p-2 rounded-full shrink-0 text-pump-dark" data-id="element-295">
                <CheckIcon className="w-6 h-6 sm:w-8 sm:h-8" strokeWidth={3} data-id="element-296" />
              </div>
              <p className="text-white font-bold text-lg sm:text-xl" data-id="element-297">
                O podés tener todo eso resuelto, integrado, listo para usar, por
                menos de lo que gastás en una certificación de fin de semana.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}